import { useState, useEffect } from 'react';
import API from '../api/axios';
import ViewModal from './ViewModal';

export default function ViewList({ selectedViewId, onSelectView, onViewSaved, onViewsLoaded }) {
  const [views, setViews] = useState([]);
  const [folders, setFolders] = useState([]);
  const [tags, setTags] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editView, setEditView] = useState(null);

  const fetchViews = async () => {
    const { data } = await API.get('/views');
    setViews(data);
    return data;
  };

  useEffect(() => {
    fetchViews().then((data) => {
      if (onViewsLoaded) onViewsLoaded(data);
    });
    const fetchFolders = async () => {
      const { data } = await API.get('/folders');
      setFolders(data);
    };
    const fetchTags = async () => {
      const { data } = await API.get('/tags');
      setTags(data);
    };
    fetchFolders();
    fetchTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => {
    setEditView(null);
    setShowModal(true);
  };

  const handleEdit = (view) => {
    setEditView(view);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this view?')) return;
    await API.delete(`/views/${id}`);
    fetchViews();
    if (selectedViewId === id) onSelectView(null, '');
  };

  const handleSave = async (viewData) => {
    if (editView) {
      await API.put(`/views/${editView.id}`, viewData);
    } else {
      await API.post('/views', viewData);
    }
    setShowModal(false);
    fetchViews();
    if (onViewSaved) onViewSaved();
  };

  const handleMoveUp = async (view) => {
    const idx = views.findIndex((v) => v.id === view.id);
    if (idx <= 0) return;
    const reordered = [...views];
    [reordered[idx - 1], reordered[idx]] = [reordered[idx], reordered[idx - 1]];
    await API.put('/views/reorder', { view_ids: reordered.map((v) => v.id) });
    fetchViews();
  };

  const handleMoveDown = async (view) => {
    const idx = views.findIndex((v) => v.id === view.id);
    if (idx < 0 || idx >= views.length - 1) return;
    const reordered = [...views];
    [reordered[idx], reordered[idx + 1]] = [reordered[idx + 1], reordered[idx]];
    await API.put('/views/reorder', { view_ids: reordered.map((v) => v.id) });
    fetchViews();
  };

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
        <strong>Views</strong>
        <button className="btn btn-sm btn-primary" onClick={handleCreate}>+ New</button>
      </div>
      <div className="p-2">
        {views.length === 0 && <small className="text-muted">No views yet</small>}
        {views.map((v) => {
          const isSelected = v.id === selectedViewId;
          return (
            <div
              key={v.id}
              className={`d-flex align-items-center rounded px-2 py-1 ${isSelected ? 'bg-primary text-white' : 'hover-bg'}`}
              style={{ cursor: 'pointer' }}
            >
              <span className="flex-grow-1 text-truncate" onClick={() => onSelectView(v.id, v.name)}>
                {v.name}
              </span>
              <div className="dropdown" onClick={(e) => e.stopPropagation()}>
                <button
                  className={`btn btn-sm p-0 ${isSelected ? 'text-white' : 'text-muted'}`}
                  data-bs-toggle="dropdown"
                  style={{ lineHeight: 1, boxShadow: 'none', outline: 'none', border: 'none' }}
                  onClick={(e) => {
                    document.querySelectorAll('.dropdown-menu.show').forEach((menu) => {
                      if (menu !== e.currentTarget.nextElementSibling) {
                        menu.classList.remove('show');
                      }
                    });
                  }}
                >
                  &#8942;
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li><button className="dropdown-item" onClick={() => handleMoveUp(v)}>Move Up</button></li>
                  <li><button className="dropdown-item" onClick={() => handleMoveDown(v)}>Move Down</button></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item" onClick={() => handleEdit(v)}>Edit</button></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item text-danger" onClick={() => handleDelete(v.id)}>Delete</button></li>
                </ul>
              </div>
            </div>
          );
        })}
      </div>
      {showModal && (
        <ViewModal
          view={editView}
          onSave={handleSave}
          onClose={() => setShowModal(false)}
          folders={folders}
          tags={tags}
        />
      )}
    </div>
  );
}
